import React, { useState } from 'react';
import { Button, Carousel } from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from '@inertiajs/react';

import logo from '@/../../public/logo.png'
import { Heart } from 'iconsax-react';
export default function PatientExperience() {
    const { t, i18n } = useTranslation();
    const [activeIndex, setActiveIndex] = useState(0);

    const handleActiveIndex = (current: number, next: number) => {
        setActiveIndex(next);
    };

    return (
        <>
            <div className='m-5 py-5 px-8  grid grid-cols-1 ' >
                <div className='flex'>

                    <p className="font-sans text-sm lg:text-base font-bold  text-custom-dark-blue  p-4 mb-2 ">{t('patient_experince.title')}</p>

                </div>

                <Carousel
                beforeChange={handleActiveIndex}
                dotPosition="top"
                autoplaySpeed={5000}
                >
                    {/* Slide 1 */}
                    <div className="" >
                        <div className="grid grid-cols-2 gap-8">
                            <div className="h-full xs:hidden bg-center mx-auto flex items-center justify-center ">
                                <img src={logo} alt="Patient" className="w-full object-cover " />
                            </div>

                            <div className={`flex flex-col gap-6 ps-10 px-8 bg-custom-dark-blue rounded-s-full py-10 items-center ${activeIndex === 0 ? 'animate-fadeleft' : ''} xs:col-span-2 xs:rounded-lg`}
                                style={{
                                    animationDelay: '0s'
                                }}
                            >
                                <p className={`font-bold text-white text-sm lg:text-base px-10 font-sans xs:px-0 xs:text-center`}>

                                    {t('patient_experince.subtitle_one')}
                                </p>
                                <p className={`font-bold text-white text-sm lg:text-base font-sans flex justify-between items-center gap-4  xs:px-0 xs:text-center xs:flex-col`}>
                                    <Heart size={24} />
                                    {t('patient_experince.subtitle_two')}
                                </p>

                                <Link
                                    href={route('client.patientexperince.create', { locale: i18n.language })}
                                >
                                    <Button
                                        className='rounded-full font-sans font-bold text-sm lg:text-base p-6 hover:!text-white hover:!bg-custom-dark-blue hover:!borde-white !text-custom-dark-blue hover:!border-4 hover:!border-white dark:!text-white'
                                    >

                                        {t('patient_experince.btn')}
                                    </Button>
                                </Link>

                            </div>
                        </div>
                    </div>

                    {/* Slide 2 */}
                    <div className="">
                        <div className="grid grid-cols-2 gap-8">
                            <div className="h-full xs:hidden bg-center mx-auto flex items-center justify-center">
                                <img src={logo} alt="Patient" className="w-full object-cover " />
                            </div>

                            <div className={`flex flex-col gap-6 ps-10 px-8 bg-custom-dark-blue rounded-s-full py-10 items-center ${activeIndex === 0 ? 'animate-fadeleft' : ''} xs:col-span-2 xs:rounded-lg`}
                                style={{
                                    animationDelay: '0s'
                                }}
                            >
                                <p className={`font-bold text-white text-sm lg:text-base px-10 font-sans xs:px-0 xs:text-center`}>

                                    {t('patient_experince.subtitle_one')}
                                </p>
                                <p className={`font-bold text-white text-sm lg:text-base font-sans flex justify-between items-center gap-4 xs:px-0 xs:text-center xs:flex-col`}>
                                    <Heart size={42} />
                                    {t('patient_experince.subtitle_two')}
                                </p>

                                <Link
                                    href={route('client.patientexperince.create', { locale: i18n.language })}
                                >
                                    <Button
                                        className='rounded-full font-sans font-bold text-sm lg:text-base p-6 hover:!text-white hover:!bg-custom-dark-blue hover:!borde-white !text-custom-dark-blue hover:!border-4 hover:!border-white dark:!text-white'
                                    >

                                        {t('patient_experince.btn')}
                                    </Button>
                                </Link>

                            </div>
                        </div>
                    </div>

                </Carousel>
            </div>

        </>
    );
}
